import { fastdom, useBanner, useBannerAnimation, useBannerStylesheet, useResettableAnimation } from "../../..";
import { AnimatedCss } from "../..";
import { useSuspendedComponentsMounted, yieldLazyLoad } from "@devowl-wp/react-utils";
const BannerContent = yieldLazyLoad(import( /* webpackMode: "eager" */"./content").then(_ref => {
  let {
    BannerContent
  } = _ref;
  return BannerContent;
}), "BannerContent");
const NEEDED_SUSPENDED_COMPONENTS_TO_BE_VISIBLE = ["BannerContent", "BannerHeader", "BannerBody", "BannerFooter", "BodyDescription"];
const BannerAnimatedContent = () => {
  const {
    inner
  } = useBannerStylesheet();
  const banner = useBanner();
  const {
    layout: {
      animationInDuration,
      animationOutDuration
    },
    animationVisible
  } = banner;
  const [Provider, contextValue] = useSuspendedComponentsMounted(NEEDED_SUSPENDED_COMPONENTS_TO_BE_VISIBLE, fastdom.mutate.bind(fastdom));
  const {
    useAnimationIn,
    useAnimationOut
  } = useBannerAnimation()(banner.layout);
  const [stateAnimationIn, stateAnimationInDuration] = useResettableAnimation(useAnimationIn, animationInDuration);
  const [stateAnimationOut, stateAnimationOutDuration] = useResettableAnimation(useAnimationOut === "none" ? "fadeOut" : useAnimationOut, useAnimationOut === "none" ? 0 : animationOutDuration);
  return h(Provider, {
    value: contextValue
  }, h(AnimatedCss, {
    animationIn: stateAnimationIn,
    animationInDuration: stateAnimationInDuration,
    animationOut: stateAnimationOut,
    animationOutDuration: stateAnimationOutDuration,
    isVisible: animationVisible,
    areAllSuspendedComponentsVisible: contextValue.completed,
    className: inner
  }, h(BannerContent, null)));
};
export { BannerAnimatedContent };